export let myOutlookLabel = "tanv0c";
export let outlookTodayLabel = "Garttb";
export let outlookTodayNewBriefingLabel = "AjM1ke";
export let automationsLabel = "IbO4eb";
export let myMirrorLabel = "xR2Jcb";
export default {myOutlookLabel,outlookTodayLabel,outlookTodayNewBriefingLabel,automationsLabel,myMirrorLabel};